import Transform from "@ember-data/serializer/transform";
import VitalSignItem from "parog-web/models/vital-sign/vital-sign-item";

export default class VitalSignItemsTransform extends Transform {
  override deserialize(serialized) {
    return serialized.map(
      item =>
        new VitalSignItem(
          item["id"],
          item["enabled"],
          item["frequency"],
          item["forgetting_number"]
        )
    );
  }

  override serialize(deserialized) {
    const result = deserialized.map(item => {
      return {
        id: item.id,
        enabled: item.enabled,
        frequency: item.frequency,
        forgetting_number: item.forgettingNumber
      };
    });

    return result;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "vital-sign-items": VitalSignItemsTransform;
  }
}
